import React from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import WelcomeScreenCard from './welcome_screen_card';
import { gaps } from 'components/layout/stack';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${gaps['2xl']};
  justify-content: center;

  @media (max-width: 960px) {
    gap: ${gaps.lg};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.sm};
  justify-content: center;

  & > * {
    margin: 0;
  }

  @media (min-width: 551px) {
    align-items: center;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: normal;
`;

const Subtitle = styled.div`
  font-size: 16px;
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${gaps.md};
  justify-content: center;
  // 1-3, 5-6 all look good with 1000px, only exception for 4 cards to be 2x2
  max-width: ${props => props.pathCount === 4 ? '800px' : '1000px'};

  @media (max-width: 960px) {
    gap: ${gaps.sm};
  }
`;

const WelcomeScreen = observer(({ learningPaths, signedIn, onLearningPathClick }) => {
  if (!learningPaths || learningPaths.length === 0) {
    return null;
  }

  const title = signedIn
    ? AppUI.site.learningPathsWelcomeTitleSignedIn
    : AppUI.site.learningPathsWelcomeTitleSignedOut;

  const subtitle = signedIn
    ? AppUI.site.learningPathsWelcomeSubtitleSignedIn
    : AppUI.site.learningPathsWelcomeSubtitleSignedOut;

  return (
    <Wrapper>
      <TextWrapper>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TextWrapper>
      <CardsWrapper pathCount={learningPaths.length}>
        {learningPaths.map(learningPath => (
          <WelcomeScreenCard
            key={learningPath.id}
            title={learningPath.name}
            subtitle={learningPath.subtitle}
            imageUrl={learningPath.imageUrl}
            levelAbbreviation={learningPath.levelAbbreviation}
            onClick={() => onLearningPathClick(learningPath.id)}
          />
        ))}
      </CardsWrapper>
    </Wrapper>
  );
});

export default WelcomeScreen;